import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
//import {jwtDecode }from 'jwt-decode'; // Correct import

import { jwtDecode } from "jwt-decode";
const InactivityHandler = () => {
  const logoutTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const tokenTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = () => {
      const token = localStorage.getItem('d_c_c_t');
      if (!token) return;

      try {
        //const decoded = jwtDecode(token);
        const decoded: { exp: number } = jwtDecode(token);

        // Check if the token is already expired
        const currentTime = Math.floor(Date.now() / 1000);
        if (decoded.exp < currentTime) {
          toast('Session expired. Please log in again.', { type: 'warning' });
        } else {
          toast('User logged out due to inactivity', { type: 'info' });
        }

        // Clear localStorage and navigate to login
        localStorage.clear();
        navigate('/login');
      } catch (error) {
        // Fallback in case of a decoding error
        toast('An error occurred during logout. Please log in again.', { type: 'error' });
        localStorage.clear();
        navigate('/login');
      }
    };

    // Start the token expiration timeout (2 hours)
    const startTokenTimeout = () => {
      if (tokenTimeoutRef.current) {
        clearTimeout(tokenTimeoutRef.current);
      }

      const token = localStorage.getItem('d_c_c_t');
      if (token) {
        try {
          const decoded: { exp: number } = jwtDecode(token);
          const currentTime = Math.floor(Date.now() / 1000);
          const timeLeft = (decoded.exp - currentTime) * 1000;

          if (timeLeft > 0) {
            tokenTimeoutRef.current = setTimeout(handleLogout, timeLeft);
          } else {
            handleLogout();
          }
        } catch (error) {
          handleLogout();
        }
      } else {
        handleLogout();
      }
    };

    // Start the inactivity logout timeout (10 minutes)
    const startLogoutTimeout = () => {
      if (logoutTimeoutRef.current) {
        clearTimeout(logoutTimeoutRef.current);
      }
      logoutTimeoutRef.current = setTimeout(handleLogout, 600000); // 10 minutes
    };

    // Add event listeners to reset inactivity timeout
    const resetInactivityTimeout = () => {
      startLogoutTimeout();
    };

    const events = ['mousemove', 'keydown', 'scroll', 'click'];
    events.forEach(event => window.addEventListener(event, resetInactivityTimeout));

    // Initialize both timeouts
    startTokenTimeout();
    startLogoutTimeout();

    // Cleanup on component unmount
    return () => {
      if (logoutTimeoutRef.current) clearTimeout(logoutTimeoutRef.current);
      if (tokenTimeoutRef.current) clearTimeout(tokenTimeoutRef.current);
      events.forEach(event => window.removeEventListener(event, resetInactivityTimeout));
    };
  }, [navigate]);

  return null; // This component doesn't render anything
};

export default InactivityHandler;
